// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip_tooltip__GjMrC","no_border":"tooltip_no_border__wVqQ2","wrapper":"tooltip_wrapper__fVhnP","show":"tooltip_show__cDre8","arrow":"tooltip_arrow__iQOz9"};